<template>
  <div class="row">
    <profile-section-header title="Background Information" />
    <ProfileSubSectionHeader title="Work History" icon="work-history-icon" />
    <div class="experience-list" v-if="experiences.length > 0">
      <div
        v-for="(experience, index) in experiences"
        :key="index"
        class="experience-item"
      >
        <p v-if="experience.name" class="company-name">{{ experience.name }}</p>
        <p v-if="experience.position" class="job-title">
          {{ experience.position }}
        </p>
        <p class="dates">
          {{ experience.from }} –
          {{ experience.current ? "Current" : experience.to }}
        </p>
        <div
          v-if="experience.dailyResponsibilities"
          class="description"
          v-html="experience.dailyResponsibilities"
        ></div>
        <p class="reason-for-leaving">
          <strong>Reason for Leaving:</strong>
          {{ experience.reasonForLeaving || "None given" }}
        </p>
      </div>
    </div>
    <p v-else class="no-experience">None listed</p>
    <empty-profile-item-message v-if="isEditing && experiences.length < 1" />
    <ul class="profile-status-list has-references">
      <GfbOptionDisplay
        :status="booleanToOptionStatus(profile.jobSeeker.hasReferences)"
        text="Professional References Available"
      />
    </ul>
  </div>
</template>

<script>
import EmptyProfileItemMessage from "@/components/Profile/EmptyProfileItemMessage"
import ProfileSectionHeader from "../ProfileSectionHeader.vue"
import ProfileSubSectionHeader from "../ProfileSubSectionHeader.vue"
import GfbOptionDisplay from "@/components/GfbOptionDisplay"
import { booleanToOptionStatus } from "@/utils/converters"

export default {
  name: "candidate-profile-work",
  components: {
    EmptyProfileItemMessage,
    ProfileSectionHeader,
    ProfileSubSectionHeader,
    GfbOptionDisplay,
  },
  methods: {
    booleanToOptionStatus,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      experiences: this.profile.jobSeeker?.previousCompaniesWorkedFor ?? [],
    }
  },
  watch: {
    profile(newVal) {
      this.experiences = newVal.jobSeeker?.previousCompaniesWorkedFor ?? []
    },
  },
}
</script>

<style lang="scss" scoped>
.experience-list {
  width: 100%;
}

.experience-item {
  padding: 16px;
  border-radius: 12px;
  border: 1px solid var(--Blue-50, #d6e1f3);
  margin-bottom: 12px;

  &:last-of-type {
    margin-bottom: 0;
  }
}

.company-name {
  font-weight: 700;
  font-size: 1rem;
  color: var(--Gray-900, #343946);
  margin-bottom: 0;
}

.job-title {
  font-weight: 700;
  font-size: 0.9375rem;
  color: var(--Gray-800, #3a4252);
  margin-bottom: 0;
}

.dates {
  font-size: 0.875rem;
  color: var(--Gray-600, #525e77);
  margin-bottom: 0;
}

.description {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  color: inherit;
  white-space: normal;
}

.profile-status-list {
  list-style: none;
  padding: 0;

  li {
    margin-bottom: 0;
  }
}

.has-references {
  font-weight: 600;
  color: var(--Gray-800, #3a4252);
  margin-top: 32px;
  width: 100%;
}

.no-experience {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
}

.reason-for-leaving {
  font-size: 0.875rem;
  color: var(--Gray-600, #525e77);
  margin-top: 0.5rem;
  margin-bottom: 0;
}
</style>
